const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/1102',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/leadership',
        title: 'Work Life'
      },
      {
        url: '/entertainment',
        title: 'Creativity'
      },
      {
        url: '/ideas',
        title: 'Impact'
      },
      // {
      //   url: '/leadership',
      //   title: 'Leadership'
      // },
      // {
      //   url: '/entertainment',
      //   title: 'Entertainment'
      // },
      // {
      //   url: '/ideas',
      //   title: 'Ideas'
      // },
      {
        url: '/section/audio',
        title: 'Audio'
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/recommender',
        title: 'Recommender',
        removeOnScale: true
      }
    ]
  }
};

export default data;
